import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

/**
 * Calls the WebSocket with `get_quick_actions` message
 */
export const getQuickActions = () => {
  return call(websocketFetch, 'get_quick_actions');
};
